import {HTMLAttributes} from 'react';
import styled from 'styled-components';
import {LoadingBar} from '@/components/LoadingBar';
import {Typography} from '@/components/Typography';
import {Divider, Flexbox, FlexCenter, PaddingBox} from '@/styled-components';
import {palette} from '@/styles/palette';
import {withComma} from '@/utils';
import {CompareAvgIcon, CompareAvgText} from '../CompareAverage';
import {BoxTitle, SubText, ValueFormatText, ValueText} from '../StyledComponents';

interface IProps {
  title: string;
  total?: number;
  sidoAvg?: number;
  sidoName?: string;
  loading?: boolean;
  unit?: string;
}

export const TotalAvgItem = ({
  title,
  total,
  sidoAvg,
  sidoName,
  loading,
  unit = '명',
  ...props
}: IProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <Block {...props}>
      <BoxTitle>{title}</BoxTitle>
      <PaddingBox top={3} bottom={7} style={{display: 'flex', flexGrow: 1}}>
        {!!total ? (
          <FlexCenter style={{flexGrow: 1}}>
            {!!sidoAvg && (
              <CompareAvgIcon
                className="avg-icon"
                total={total}
                avg={sidoAvg}
              />
            )}
            <ValueText>
              {withComma(Math.round(total))}
              <ValueFormatText>&nbsp;{unit}</ValueFormatText>
            </ValueText>
          </FlexCenter>
        ) : (
          <FlexCenter style={{flexGrow: 1}}>
            {loading ? (
              <LoadingBar color={palette.textSecondary} size={18} />
            ) : (
              <Typography variant="medium12" opacity="0.5" align="center">
                정보가 없습니다
              </Typography>
            )}
          </FlexCenter>
        )}
      </PaddingBox>
      {!!total && !!sidoAvg && (
        <>
          <Divider />
          <PaddingBox top={2}>
            <Flexbox>
              <SubText align="center">
                {sidoName} 평균 대비{' '}
                <CompareAvgText total={total} avg={sidoAvg} />
              </SubText>
            </Flexbox>
          </PaddingBox>
        </>
      )}
    </Block>
  );
};

const Block = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  .avg-icon {
    margin-right: 4px;
  }
  ${SubText} {
    flex-grow: 1;
  }
`;
